import type { ValueOf } from 'cpool-utils';

export const CHAT_LIST_VARIANTS = {
    PAGE: 'page',
    PANEL: 'panel',
} as const;

export type ChatListVariant = ValueOf<typeof CHAT_LIST_VARIANTS>;
